import { combineReducers } from "redux";

import LoginReducer from './Redux/Reducer/LoginReducer';
import ForgotPasswordReducer from './Redux/Reducer/ForgotPasswordReducer';
import OtpReducer from "./Redux/Reducer/OtpReducer";
import GetUserReducer from "./Redux/Reducer/UserReducer";
import GetBankReducer from "./Redux/Reducer/BankReducer";
import GetHolidayReducer from "./Redux/Reducer/HolidayReducer";
import GetAnnouncementReducer from "./Redux/Reducer/AnnouncementReducer";
import HomeReducer from "./Redux/Reducer/HomeReducer";
import ThemeListReducer from "./Redux/Reducer/ThemeListReducer";
import ZipReducer from "./Redux/Reducer/ZipReducer";
import ProductReducer from "./Redux/Reducer/ProductReducer";
import VideosReducer from "./Redux/Reducer/VideosReducer";
import AdminReducer from "./Redux/Reducer/AdminReducer";
import mobileConfigurationReducer from "./Redux/Reducer/mobileConfigurationReducer";
import ContactUsReducer from "./Redux/Reducer/ContactUsReducer";
import QuestionReducer from "./Redux/Reducer/QuestionReducer"
import ServicesReducer from "./Redux/Reducer/ServicesReducer"
import SettingsReducer from "./Redux/Reducer/SettingsReducer"
import HelpReducer from "./Redux/Reducer/HelpReducer"
import ServiceRequestReducer from "./Redux/Reducer/ServiceRequestReducer";
import ChangePasswordReducer from "./Redux/Reducer/ChangePasswordReducer";
import UpdatePasswordReducer from "./Redux/Reducer/UpdatePasswordReducer";
import RegistrationReducer from "./Redux/Reducer/SignupReducer"

export default combineReducers({
    LoginReducer,
    ForgotPasswordReducer,
    OtpReducer,
    GetUserReducer,
    GetBankReducer,
    GetHolidayReducer,
    GetAnnouncementReducer,
    ThemeListReducer,
    HomeReducer,
    ZipReducer,
    ProductReducer,
    VideosReducer,
    AdminReducer,
    mobileConfigurationReducer,
    ContactUsReducer,
    QuestionReducer,
    ServicesReducer,
    SettingsReducer,
    HelpReducer,
    ServiceRequestReducer,
    ChangePasswordReducer,
    UpdatePasswordReducer,
    RegistrationReducer
});